// extracted by mini-css-extract-plugin
export default {"V2AMap":"V2AMap--u7KuP","V2AMapCon":"V2AMapCon--YCa7x","markerAnimationScale":"markerAnimationScale--GSR1r"};